import { OrganisationCategory } from '../types/enums/OrganisationCategory';

export const ORGANISATION_CATEGORY_OPTIONS = [
  { value: OrganisationCategory.SHARED, label: 'Shared' },
  { value: OrganisationCategory.PRIVATE, label: 'Private' },
] as const;
